import api from "@/app/_module/services/api";
import { getApiUrl } from "@/app/_module/services/config";
import { endpoint } from "@/app/_module/services/endpoints";

export interface AgencyTvSettings {
  agencySlug: string | null;
  displayUrl: string | null;
  enabled: boolean;
  hasPin: boolean;
  /** The screen code, returned exactly once when the display is first created. */
  newPin?: string | null;
  /** Agency-wide monthly premium goal shown on the wall, whole dollars. */
}

interface ApiEnvelope<T> {
  data?: T;
  statusCode?: number;
}

function unwrap<T>(response: { data: unknown }): T {
  let value = response.data as ApiEnvelope<unknown> | unknown;

  for (let depth = 0; depth < 2; depth += 1) {
    if (
      value
      && typeof value === "object"
      && "data" in value
      && "statusCode" in value
    ) {
      value = (value as ApiEnvelope<unknown>).data;
      continue;
    }
    break;
  }

  return value as T;
}

export async function getAgencyTvSettings(agencyId: string): Promise<AgencyTvSettings> {
  const response = await api.get<AgencyTvSettings>({
    url: getApiUrl(endpoint.agencyTv.getSettings(agencyId)),
    auth: true,
  });

  return unwrap<AgencyTvSettings>(response);
}

export async function updateAgencyTvSettings(
  agencyId: string,
  input: { enabled?: boolean; pin?: string },
): Promise<AgencyTvSettings> {
  const response = await api.put<AgencyTvSettings>({
    url: getApiUrl(endpoint.agencyTv.updateSettings(agencyId)),
    body: input,
    auth: true,
  });

  return unwrap<AgencyTvSettings>(response);
}

export async function lockAgencyTvSessions(agencyId: string): Promise<void> {
  await api.post({
    url: getApiUrl(endpoint.agencyTv.lockSessions(agencyId)),
    auth: true,
  });
}
